import React, { Component } from 'react';
import { Table, InputNumber, Popconfirm, Button, message } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class EditableCell extends Component {
    handleSelectChange = (value) => {
        const { type } = this.props;
        this.props.onChange({ [type]: value });
    }

    handleHighSearchInputChange = (id, options) => {
        const option = options.find(i => i.value == id);
        const { value, text } = option || {};
        this.props.onChange({
            competitionCompanyId: value,
            competitionCompanyName: text,
            isSelectFalse: id ? value ? false : true : false,
        });
    }
 
    getContent = () => {
        const { type, params, hospitalDepartmentId } = this.props;
        const { competitionCompanyId, competitionCompanyName, crcNum, reviewDepartmentCompetitionId } = params;
        if (type === 'competitionCompany') {
            return (
                <HighSearchInput
                    isEdit={true}
                    keyword='keyword'
                    style={{ width: '100%' }}
                    placeholder="输入名称检索"
                    params={{ limit: 20, hospitalDepartmentId, reviewDepartmentCompetitionId }}
                    url={API_URL.hospital.queryReviewDepartmentCompany}
                    initValue={{ key: competitionCompanyId, label: competitionCompanyName }}
                    config={{ id: 'reviewDepartemntCompanyId', name: 'companyName' }}
                    onChange={(id, options) => this.handleHighSearchInputChange(id, options)}
                />
            )
        } else if (type === 'crcNum') {
            return (
                <InputNumber
                    placeholder='请输入'
                    min={0}
                    precision={0}
                    style={{ width: '100%' }}
                    value={crcNum}
                    onChange={value => this.handleSelectChange(value)}
                />
            )
        }
    }

    render () {
        const { editable, value } = this.props;
        return (
            <div>
                {
                    editable ?
                        this.getContent()
                    :
                        value
                }
            </div>
        )
    }
}

class CompanyTable extends Component {
    state = {
        count: 0,
        loading: false,
        dataSource: [],
    }

    componentDidMount() {
        const { dataSource } = this.props;
        const newDataSource = dataSource.map((item, index) => {
            item.key = index;
            return item;
        });
        this.setState({
            count: dataSource.length,
            dataSource: newDataSource,
        });
    }

    componentWillReceiveProps(nextProps) {
        const { isEdit, loading, dataSource = [] } = nextProps;
        if ((!this.props.isEdit && isEdit) || (this.props.loading && !loading)) {
            const newDataSource = dataSource.map((item, index) => {
                item.key = index;
                return item;
            });
            this.setState({
                count: dataSource.length,
                dataSource: newDataSource,
            });
        }
    }

    handleChange = (value, key) => {
        const newData = [...this.state.dataSource];
        const target = newData.find(item => key === item.key);
        if (target) {
            const entries = Object.entries(value || {});
            entries.forEach(entry => {
                target[entry[0]] = entry[1];
            });
            this.setState({ dataSource: newData });
        }
    }

    edit = (key) => {
        const newData = [...this.state.dataSource];
        const target = newData.find(item => key === item.key);
        newData.forEach(i => i.editable = false);
        if (target) {
            target.editable = true;
            this.setState({ dataSource: newData });
        }
    }

    save = (key) => {
        const { reviewDepartmentId, hospitalDepartmentId } = this.props;
        const newData = [...this.state.dataSource];
        const target = newData.find(item => key === item.key);
        if (target) {
            const { isSelectFalse, crcNum, competitionCompanyId, reviewDepartmentCompetitionId } = target;
            if (!competitionCompanyId) {
                message.warning('请选择竞争公司');
                return;
            } else if (isSelectFalse) {
                message.warning('请选择正确的竞争公司');
                return;
            }
            if (!(crcNum >= 0)) {
                message.warning('请填写CRC人数');
                return;
            }
            const url = reviewDepartmentCompetitionId ? API_URL.hospital.modifyReviewDepartmentCompetition : API_URL.hospital.addReviewDepartmentCompetition;
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url,
                data: {
                    reviewDepartmentId,
                    hospitalDepartmentId,
                    ...target,
                },
                dataType: 'json',
                doneResult: res => {
                    const { success, reviewDepartmentId, reviewDepartmentCompetitionId } = res;
                    message.success(success);
                    if (reviewDepartmentCompetitionId) {
                        target.reviewDepartmentCompetitionId = reviewDepartmentCompetitionId;
                    }
                    target.editable = false;
                    this.setState({
                        loading: false,
                        dataSource: newData,
                    }, () => {
                        this.props.onChange(reviewDepartmentId);
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                }
            };
            $.sendRequest(options);
        }
    }

    cancel = (key) => {
        const newData = [...this.state.dataSource];
        let idx;
        newData.forEach((item, index) => {
            if (item.key == key) {
                if (item.reviewDepartmentCompetitionId) {
                    idx = index
                    this.setState({ loading: true });
                    const options = {
                        method: 'POST',
                        url: API_URL.hospital.deleteReviewDepartmentCompetition,
                        data: {
                            reviewDepartmentCompetitionId: item.reviewDepartmentCompetitionId,
                        },
                        dataType: 'json',
                        doneResult: res => {
                            message.success(res.success);
                            newData.splice(idx, 1);
                            this.setState({
                                loading: false,
                                dataSource: newData,
                            });
                        },
                        errorResult: () => {
                            this.setState({ loading: false });
                        }
                    };
                    $.sendRequest(options);
                } else {
                    idx = index;
                    if (idx >= 0) {
                        newData.splice(idx, 1);
                        this.setState({ dataSource: newData });
                    }
                }
            }
        });
    }

    getColumns = () => {
        const { isEdit, hospitalDepartmentId } = this.props;
        const columns = [{
            title: '竞争公司名称',
            dataIndex: 'competitionCompanyName',
            key: 'competitionCompanyName',
            width: 300,
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={record}
                        type='competitionCompany'
                        hospitalDepartmentId={hospitalDepartmentId}
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }, {
            title: 'CRC人数',
            dataIndex: 'crcNum',
            key: 'crcNum',
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={record}
                        type='crcNum'
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }];

        if (isEdit) {
            columns.push({
                title: '操作',
                key: 'operation',
                width: 80,
                render: (text, record, index) => {
                    const { key, editable } = record;
                    return (
                        <span>
                            {
                                editable ?
                                    <a onClick={() => this.save(key)}>保存</a>
                                :
                                    <a onClick={() => this.edit(key)}>修改</a>
                            }
                            <span className="ant-divider" />
                            <Popconfirm title="确定要删除该行数据?" onConfirm={() => this.cancel(key)}>
                                <a>删除</a>
                            </Popconfirm>
                        </span>
                    )
                },
            });
        }
        return columns;
    }

    handleAdd = () => {
        const { count, dataSource } = this.state;
        const newData = {
          key: count,
          editable: true,
        };
        dataSource.forEach(i => i.editable = false);
        this.setState({
          dataSource: [...dataSource, newData],
          count: count + 1,
        });
    }

    render() {
        const { loading, dataSource } = this.state;
        const { isEdit } = this.props;
        return (
            <div style={{ marginBottom: 10 }}>
                { isEdit && <Button onClick={this.handleAdd} style={{ marginBottom: 10 }}>添加行</Button> }
                <Table
                    bordered
                    loading={loading}
                    pagination={false}
                    scroll={{ y: 280 }}
                    columns={this.getColumns()}
                    dataSource={dataSource}
                    rowKey={record => record.key}
                />
            </div>
        )
    }
}

export default CompanyTable;


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/CompanyTable.js